import ShiftPatternEdit from '@/components/ezuro/constants/shifts/edit/ShiftPatternEdit.vue'
import MinutesToText from '@/components/ezuro/common/MinutesToText.vue'

export default {
  name: 'ShiftPattern',
  props: {
    pattern: {
      type: Array
    },
    canEdit: {
      type: Boolean
    },
    showLabels: {
      type: Boolean
    },
    short: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ShiftPatternEdit,
    MinutesToText
  },
  data () {
    return {
      slots: (this.pattern ? this.pattern : [])
    }
  },
  methods: {
    add: function () {
      const newType = (this.slots.length && this.slots[this.slots.length - 1].type === 'work' ? 'rest' : 'work');
      const newLength = (newType === 'work' ? 8 * 60 : 16 * 60);

      this.slots.push({
        length: newLength,
        type: newType
      });
    },
    change: function (key, el) {
      if (this.canEdit === false) {
        return;
      }
      this.$refs.editElFrm.show(key, el);
    },
    remove: function () {
      this.slots.pop();
    },
    removeByKey: function (key) {
      this.slots.splice(key, 1);
    },
    updatePattern: function (data) {
      this.slots[data.key].length = data.data.length;
      this.slots[data.key].type = data.data.type;
    }
  }
}
